/**
 * enCustomers — the customer list's source badge and the "Came from" panel.
 *
 * Split out of `en.ts`, which sits at the 500-line ceiling the `fileSize`
 * ratchet enforces. The source labels are the whole reason this slice exists:
 * every acquisition channel the server derives (popup, BuzzPage, lead ad,
 * form, booking, Shopify, WhatsApp…) used to collapse to "Direct" in the UI,
 * so a merchant running four capture surfaces saw one word for all of them.
 */
export const enCustomers = {
  // ── List page header ──────────────────────────────────────────────────
  'customers.pageTitle': 'Customers',
  'customers.pageSubtitle':
    'Identity, {transactions}, and engagement for every contact.',
  'customers.pageSubtitleStore':
    'Identity, purchases, and engagement for every shopper.',

  // ── Acquisition source badge ──────────────────────────────────────────
  'customers.source.tiktok': 'TikTok',
  'customers.source.facebook': 'Facebook',
  'customers.source.google': 'Google',
  'customers.source.instagram': 'Instagram',
  'customers.source.email': 'Email',
  'customers.source.direct': 'Direct',
  'customers.source.referral': 'Referral',
  'customers.source.organic': 'Organic',
  'customers.source.popup': 'Popup',
  'customers.source.buzzpage': 'BuzzPage',
  'customers.source.landing': 'Landing page',
  'customers.source.leadAd': 'Lead ad',
  'customers.source.form': 'Form',
  'customers.source.booking': 'Booking',
  'customers.source.shopify': 'Shopify',
  'customers.source.whatsapp': 'WhatsApp',
  'customers.source.messenger': 'Messenger',
  'customers.source.telegram': 'Telegram',
  'customers.source.funnel': 'Funnel',
  'customers.contact.instagram': 'Instagram',
  'customers.source.import': 'Import',
  'customers.source.api': 'API',
  'customers.source.manual': 'Manual',

  // ── Customer 360 header: pipeline stage + follower status ─────────────
  'customers.stage.new': 'New lead',
  'customers.stage.contacted': 'Contacted',
  'customers.stage.qualified': 'Qualified',
  'customers.stage.proposal': 'Proposal',
  'customers.stage.won': 'Won',
  'customers.stage.lost': 'Lost',
  'customers.follows.instagram': 'Follows you on Instagram',
  'customers.follows.notInstagram': 'Not following on Instagram',
  'customers.follows.facebook': 'Follows your Page',
  'customers.follows.notFacebook': 'Not following your Page',

  // ── "Came from" — first and last attribution touch ────────────────────
  'customers.attribution.title': 'Came from',
  'customers.attribution.firstTouch': 'First touch',
  'customers.attribution.lastTouch': 'Last touch',
  'customers.attribution.landingPage': 'Landing page',
  'customers.attribution.keyword': 'Keyword',
  'customers.attribution.adId': 'Ad ID',
  'customers.attribution.campaignId': 'Campaign ID',
  'customers.attribution.fbclid': 'fbclid',
  'customers.attribution.ctwaClid': 'ctwa_clid',
} as const;
